import img1 from '../../../assets/img/destination/destination-small1.png'
import img2 from '../../../assets/img/destination/destination-small2.png'
import img3 from '../../../assets/img/destination/destination-small3.png'
import img4 from '../../../assets/img/destination/destination-small4.png'
import img5 from '../../../assets/img/destination/destination-small5.png'
import img6 from '../../../assets/img/destination/destination-small6.png'




export const DestinationsData  = [
    {
        img: img1,
        heading:"Everest trek to Base Camp",
        Price:"$105.00"
    },
    {
        img: img2,
        heading:"Kathmundu tour",
        Price:"$85.00"
    },
    {
        img: img3,
        heading:"Beautiful pokhara",
        Price:"$100.00"
    },
    {
        img: img4,
        heading:"Annapurna region",
        Price:"$75.00"
    },
    {
        img: img5,
        heading:"Chitwan national park",
        Price:"$105.00"
    },
    {
        img: img6,
        heading:"Langtang region",
        Price:"$105.00"
    },

   
]